module.exports = require('./../dist/src/on-stage/general/dist/components/ErrorSmall.js');
